import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/pc/icons/sprite.png';
const _withScopeId = n => (_pushScopeId("data-v-79744600"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "login-box-h5 h5-popup-overlay"
};
const _hoisted_2 = {
  class: "h5-popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "login-title"
}, "大赢家俱乐部，步步为赢", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-notice"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "greeting"
}, "尊敬的尊龙凯时会员，您好:"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "请前往尊龙凯时官网进行注册/登录后即可发帖喔！"), /*#__PURE__*/_createElementVNode("br")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "van-fade"
  }, {
    default: _withCtx(() => [$setup.loginBox.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "h5-popup-close",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
    }, _hoisted_4), _hoisted_5, _hoisted_6, _createElementVNode("a", {
      href: "#",
      class: "login-button",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => $setup.gotoLogin($setup.loginBox.method), ["prevent"]))
    }, " 去官网" + _toDisplayString($setup.buttonMethodText($setup.loginBox.method)), 1)])])) : _createCommentVNode("", true)]),
    _: 1
  });
}